import { render, staticRenderFns } from "./TopBottomSection.vue?vue&type=template&id=4fa28ffb&"
import script from "./TopBottomSection.vue?vue&type=script&lang=ts&"
export * from "./TopBottomSection.vue?vue&type=script&lang=ts&"
import style0 from "./TopBottomSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports